var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 91,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FAC754",
  d: "M90.333 45c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M18.378 66.536c15.679-1.38 33.821-2.006 49.556-1.612l4.354 3.555s-1.076 3.277-2.31 5.16c-.285.435-.585.885-1.024 1.158-.472.297-1.046.36-1.601.417a276 276 0 0 1-28.793 1.372c-6.195-.03-13.15-.607-17.2-5.295l-2.975-4.755z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M47.028 64.999h-3.386V14.693a1.282 1.282 0 0 1 2.565-.023L47.032 65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.273 15.919c-.199-.39-.788-.236-.773.202.488 14.393.443 28.785.979 43.178.019.484.045 1.005.259 1.38.273.484.761.574 1.196.622a53.8 53.8 0 0 0 18.334-1.162C64.593 48.13 63.325 45.956 57.85 34.54L48.27 15.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M62.587 44.498c-.994-2.19-2.149-4.582-3.657-7.71-4.102.135-8.396.146-10.972.143q.067 4.03.139 8.062c3.412.12 9.618-.191 14.486-.495zM47.733 24.713c.06 2.692.113 5.388.158 8.08 2.295.046 5.756-.153 8.865-.385L52.77 24.66c-1.898.045-3.687.053-5.037.053M67.125 56.486c-.998-3.112-1.834-5.49-2.708-7.687-5.527.352-13.061.356-16.237.341.06 2.678.135 5.351.225 8.029 3.926.259 13.488-.323 18.716-.683z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M41.692 30.953c.262-.372.847-.173.825.285-.48 10.158-.443 20.313-.98 30.472-.018.345-.044.716-.262.983-.277.345-.772.408-1.215.442a77.3 77.3 0 0 1-17.947-.72.462.462 0 0 1-.326-.686 396 396 0 0 1 15.405-24.401l4.496-6.375z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M32.766 43.95a384 384 0 0 0-3.694 5.749c4.444.259 10.388.532 12.889.341q.075-3 .142-6a315 315 0 0 1-9.337-.09M27.085 52.89a381 381 0 0 0-3.439 5.677c3.36.229 15.188.986 18.012.563q.128-2.97.217-5.94c-1.781.01-9.66.052-14.79-.3M42.182 40.905c.053-2.006.11-4.013.184-6.023-.802.004-2.032.008-3.442-.01l-1.73 2.452a381 381 0 0 0-2.283 3.382c2.76.18 5.693.308 7.275.195z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.333 0h90v90h-90z"
})))));
export { SvgAvatar2 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-2.fdb4abb3ade6afe1ca2b.svg";